import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const Container = styled.div<{ $isSent?: boolean }>`
  display: flex;
  gap: ${space('x6')};
  justify-content: ${({ $isSent }) => ($isSent ? 'center' : 'space-between')};
  align-items: center;
  padding: ${space('x10')};

  @media screen and (${query.below('desktop')}) {
    padding: ${space('x10')} ${space('marginTablet')};
    flex-direction: column;
    align-items: stretch;
  }

  @media screen and (${query.below('tablet')}) {
    padding: ${space('x10')} ${space('marginMobile')};
  }
`;

export const StyledForm = styled.form`
  width: 100%;
  display: inline-block;
  a span {
    display: block;
  }
`;

export const GridLeftContainer = styled.div<{ $isSent?: boolean }>`
  flex: 1 0 0%;
  width: 100%;
  display: ${({ $isSent }) => ($isSent ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const GridRightContainer = styled.div<{ $isSent?: boolean }>`
  flex: 0 0 auto;
  width: 33.33333333%;
  display: ${({ $isSent }) => ($isSent ? 'none' : 'block')};

  @media screen and (${query.below('max')}) {
    flex: 0 0 auto;
    width: 50%;
    margin-top: 0;
  }

  @media screen and (${query.below('desktop')}) {
    flex: 1 0 0%;
    width: 100%;
    margin-top: 0;
  }
`;
export const SentMessage = styled.div<{ $isSent?: boolean }>`
  display: ${({ $isSent }) => ($isSent ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
`;

export const InputField = styled.input`
  ${font('body-md')};
  color: ${color('fg')};
  display: inline-block;
  outline: none;
  border: 1px solid ${color('gray2')};
  width: 70%;
  height: 100%;
  font-weight: 300;
  padding: 7px 20px 10px 16px;
  background: ${color('bg')};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  &::placeholder {
    color: ${color('gray3')};
  }
  &:focus {
    color: ${color('fg')};
    border: 1px solid ${color('fg')};
  }
  @media screen and (${query.below('desktop')}) {
    width: calc(100% - 40px);
    margin-bottom: 20px;
  }
`;

export const FormLabel = styled.label`
  ${font('body-md')};
  color: ${color('fg')};
  width: 100%;
  padding-bottom: 4px;
  display: inline-flex;
  line-height: 30px;
`;

export const Header = styled.h1`
  ${font('headline-md')};
  text-align: center;
  padding-bottom: ${space('x5')};
  @media screen and (${query.below('desktop')}) {
    ${font('headline-sm')};
  }
`;

export const Text = styled.div`
  color: ${color('fg')};
  ${font('body-md-light')};
  text-align: center;
`;

export const ModalButtonWrapper = styled.div``;
